import rules from './checkUtils'
<template>

<div class="regist-container">
<el-form class="regist-form">
  <div class="title-container">
    <h3 class="title">
      {{ "Congratulations!" }}
    </h3>
    <h3 class = "title">
      {{"VOFATA warranty, You GET It!"}}
    </h3>
    <h3 class = "title2">
      {{"Thank you for choosing our case!"}}
    </h3>
  </div>
  <h3 class = "form-title">
    {{"Region"}}
  </h3>
  <el-form-item>
    <el-select v-model = "formInline.regionState" @change="$forceUpdate()" style="width : 100%">
      <el-option value="Amazon.com"></el-option>
      <el-option value="Amazon.co.uk"></el-option>
      <el-option value="Amazon.de"></el-option>
      <el-option value="Amazon.ca"></el-option>
      <el-option value="Amazon.co.jp"></el-option>
      <el-option value="Amazon.co.Partners"></el-option>
    </el-select>
  </el-form-item>
  <h3 class = "form-title">
    {{"Name"}}
  </h3>
  <el-form-item>
    <el-input v-model="formInline.name">
    </el-input>
  </el-form-item>
  <h3 class = "form-title">
    {{"Email"}}
  </h3>
  <el-form-item prop = "email">
    <el-input v-model="formInline.email">
    </el-input>
  </el-form-item>
  <h3 class = "form-title">
    {{"Order ID"}}
  </h3>
  <el-form-item>
    <el-input v-model="formInline.order" placeholder= "123-1234567-1234567">
    </el-input>
  </el-form-item>
  <el-form-item>
    <el-select v-model = "formInline.brand" @change="$forceUpdate()" style="width : 100%">
      <el-option selected="selected" value="iPhone"></el-option>
      <el-option value="Samsung"></el-option>
      <el-option value="Google"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item>
    <el-select v-model = "formInline.state" @change="$forceUpdate()" style="width : 100%">
      <el-option selected="selected" value="Subscribe Us to Get the Latest News"></el-option>
      <el-option value="Do Not Subscribe"></el-option>
    </el-select>
  </el-form-item>
  <el-button type="primary" :disabled="submissionFlag" style="width:100%;margin-bottom:30px;" @click.native.prevent="sendEmail">
    {{ "Submit" }}
  </el-button>
</el-form>

<div class="footer">
  <p><a href="https://beian.miit.gov.cn" target="_blank" class="beianLink">粤ICP备2022134206号</a></p>
</div>
</div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<script>

document.querySelector('body').setAttribute('style', 'background-color:#283443')
import axios from 'axios'
export default {
  data() {
    return {
      formInline: {
        name : '',
        email: '',
        order: '',
        brand:'Your Phone Brand',
        state:'Subscribe Us to Get the Latest News',
        regionState:'Amazon.com'
      },
      submissionFlag:false,
    }
  },
  mounted() {
        this.$message.config({
               top: 1000,
               duration: 3
         });
   },
  mounted:{
  },
  methods: {
    handleRegist: function() {
      console.log("zwy");
      axios({
        method:'post',
        baseURL:'http://vofatatech.com:8000/userInfo',
        data:{
          region:this.formInline.regionState,
          userName:this.formInline.name,
          userEmail:this.formInline.email,
          userOrder:this.formInline.order,
          userBrand:this.formInline.brand,
          userState:this.formInline.state,
        }
      });
    },
    sendEmail: function() {
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.formInline.email != '' && !regEmail.test(this.formInline.email) || this.formInline.email == '') {
          this.$message({
              message: 'Please input a correct email!',
              center: true,
              type: 'error'})
          this.formInline.email = ''
      } else {
          this.handleRegist();
          this.submissionFlag = true;
          this.$message({
              message: 'Successfully activate the warranty!',
              center: true,
              offset: 300,
              width: 100,
              type: 'success'});
      }
    }
  }
}
</script>
<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.regist-container {
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>
<style lang="scss" scoped>
$bg:#2d3a4b;
$dark_gray:#889aa4;
$light_gray:#eee;

.regist-container {
  position: relative;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  overflow: hidden;

  .regist-form {
    width: 70%;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  .title-container {
    top:10px;
    margin: 0px auto 10px auto;
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 10px auto;
      text-align: center;
      font-weight: bold;
    }
    .title2 {
      font-size: 10px;
      color: $light_gray;
      margin: 0px auto 20px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .form-title {
    font-size: 14px;
    color: $light_gray;
    margin: 0px auto 5px auto;
    text-align: left;
    font-weight: bold;
  }

  .footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #283443;
  text-align: center;
  line-height: 50px;
  font-size: 14px;
  color: #999;
}
.beianLink {
  color: white;
}

}
</style>



// WEBPACK FOOTER //
// src/App.vue